// extracted by mini-css-extract-plugin
module.exports =  {"checkbox":"_2787e5dfdf--checkbox--oMeNF","box":"_2787e5dfdf--box--aD_nX","label":"_2787e5dfdf--label--iT_qr"};